// 公共
const COMMON = {
  LOCALMODULE: '/local/module',
  COURSE: '/course',
  COURSERECOMMEND: '/course/recommend',
  LOGIN: '/auth/login',
  COURSEDETAILS: '/course/coursedetails',
  CERT: '/cert/searchcert',
  GETENTERPRISEREGISTRATION: '/enterprise/registration',
  EMPLOYEEDEGREE: '/common/employeedegree',
  EMPLOYEETITLE: '/common/employeetitle',
  CERTCLASS: '/common/certclass',
  CERTSUBCLASS: '/common/certsubclass',
  COURSEOPENJOBS: '/course/openjobs',
  JOB: '/course/job',
  LEARNLEARNDETAILS: 'learn/learndetails',
  LEARNLEARNAPPROVESTEP: 'learn/learnapprovestep',
  COMMONLEARNPAYMETHOD: '/common/learnpaymethod',
  COMMONMAKEUPPAYMETHOD: '/common/makeuppaymethod',
  SENDVERIFYCODE: '/sendverifycode',
  NEWS: '/news',
  NEWSDETAILS: '/news/details',
  NEWSTESTPLANS: '/newstestplans',
  SENDCHANGEPWDVERIFYCODE: '/sendchangepwdverifycode',
  CHANGEPASSWORD: '/changepassword',
  LEARNLEARNAPPROVECOUNT1: 'learn/learnapprovecount?LearnApproveStateId=1',
  LEARNLEARNAPPROVECOUNT2: 'learn/learnapprovecount?LearnApproveStateId=2',
  LEARNLEARNAPPROVECOUNT3: 'learn/learnapprovecount?LearnApproveStateId=3',
  MAKEUPMAKEUPAPPROVECOUNT1: 'makeup/makeupapprovecount?makeUpApproveStateId=1',
  MAKEUPMAKEUPAPPROVECOUNT2: 'makeup/makeupapprovecount?makeUpApproveStateId=2',
  MAKEUPMAKEUPAPPROVECOUNT3: 'makeup/makeupapprovecount?makeUpApproveStateId=3',
  LEARNINGMGTDETAILS: 'learningmgtdetails',
  MAKEUPMAKEUPDETAILS: '/makeup/makeupdetails',
  MAKEUPMAKEUPAPPROVESTEP: 'makeup/makeupapprovestep',
  VERIFYTCAPTCHATICKET: 'verifytcaptchaticket',
  COMMONJOB: 'common/job',
  COMMONUPLOADPIC: '/common/uploadpic',
  COMMONUPLOADFILE: '/common/uploadfile',
  STUDYRECORDDETAILS: '/study/recorddetails',

  INVOICEAPPROVEADETAILS: 'invoiceapprove/details',

  COMMONQUICKCOMMENTS: 'common/quickcomments',

  WEIXINTMPQRCODE: '/weixin/tmpqrcode'
};

// 本地
const LOCAL = {
  ENROLLSTUDENT: '/local/enrollstudent',
  ENROLL: '/local/enroll'
};

// 企业
const QYGL = {
  ENTERPRISEEMPLOYEE: '/employee/enterpriseemployee',
  ROOT: '/employee',
  LEARNREGISTRATION: '/learn/registration',
  LEARNSAVE: '/learn/save',
  LEARNCANCEL: '/learn/cancel',
  LEARNWEIXINPAYCODE: '/learn/weixinpaycode',
  LEARNWEIXINPAYRESULT: '/learn/weixinpayresult',
  LEARNENTERPRISELEARN: '/learn/enterpriselearn',
  LEARNINGMGTQY: 'learningmgt/qy',
  EMPLOYEECOMMITMENTLETTER: 'learn/employeecommitmentletter',
  MAKEUPLEARNDETAILS: '/makeup/makeuplearndetails',
  MAKEUPREGISTRATION: '/makeup/registration',
  MAKEUPENTERPRISEMAKEUP: '/makeup/enterprisemakeup',
  ENTERPRISEMYENTERPRISE: '/enterprise/myenterprise',
  LEARNUPDATEJFPZ: 'learn/updatejfpz',
  LEARNCLOSENOTICE: 'learn/closenotice',
  LEARNUPDATEEMPLOYEEPIC: 'learn/updateemployeepic',
  CMTYPE: 'cmtype',
  CMJOB: 'cmjob',
  ALLCMJOB: 'allcmjob',
  CMCERTIFICATE: 'cmcertificate',
  CMCERTIFICATEDETAILS: 'cmcertificate/details',
  CMCERTIFICATEQY: 'cmcertificate/qy',
  CMCERTIFICATEIMPORT: 'cmcertificate/import',
  CMCERTIFICATEREMOTESEARCH: 'cmcertificate/remotesearch',
  CMEMPLOYEE: 'cmemployee',
  CMEMPLOYEEDETAILS: 'cmemployee/details',
  CMPROJECT: 'cmproject',
  CMPROJECTDETAILS: 'cmproject/details',
  INVOICEAPPROVEAPPROVELEARNS: 'invoiceapprove/approvelearns',
  INVOICEAPPROVESTATES: 'invoiceapprove/states',
  INVOICEAPPROVEQY: 'invoiceapprove/qy',
  INVOICEAPPROVEAPPLY: 'invoiceapprove/apply',
  INVOICEAPPROVELAST: 'invoiceapprove/last',
  MAKEUPUPDATEJFPZ: '/makeup/updatejfpz',

  BDYTESTMGTBATCHEMPLOYEES: 'bdytestmgt/batch/employees',
  BDYTESTMGTBATCHADDEMPLOYEES: 'bdytestmgt/batch/addemployees',
  BDYTESTMGTBATCHEMPLOYEE: 'bdytestmgt/batch/employee',
  BDYTESTMGTSESSIONSELECT: 'bdytestmgt/session/select',
  BDYTESTMGTBATCHZKZEXPORTINIT: 'bdytestmgt/batch/zkz/export/init',
  BDYTESTMGTBATCHZKZEXPORT: 'bdytestmgt/batch/zkz/export',
  BDYTESTMGTBATCHZKZEXPORTEND: 'bdytestmgt/batch/zkz/export/end',

  ENTERPRISEREPORTMODIFY: 'enterprise/reportmodify',
  ENTERPRISEMODIFYAPPROVESTATES: 'enterprise/modifyapprovestates',
  ENTERPRISEMODIFYAPPROVES: 'enterprise/modifyapproves',
  ENTERPRISECONTACT: 'enterprise/contact',
  ENTERPRISEPASSWORD: 'enterprise/password',
  ENTERPRISEEMAIL: 'enterprise/email',
  ENTERPRISEQUALIFICATION: 'enterprise/qualification',

  BDYPRACTICEENROLLADDEMPLOYEES: 'bdypracticeenroll/addemployees',
  BDYPRACTICEENROLL: 'bdypracticeenroll',
  BDYPRACTICEENROLLJFPZ: 'bdypracticeenroll/jfpz',

  ZJYTESTMGTBATCHADDEMPLOYEES: 'zjytestmgt/batch/addemployees',
  ZJYTESTMGTBATCHEMPLOYEES: 'zjytestmgt/batch/employees'
};

// 运营
const YYGL = {
  APPROVELLIST: '/enterprise/approvellist',
  ENTERPRISE: '/enterprise',
  ENTERPRISEDETAILS: '/enterprise/details',
  ENTERPRISEREGISTER: '/enterprise/register',
  ENTERPRISEENTERPRISES: '/enterprise/enterprises',
  APPROVE: '/enterprise/approve',
  ENTERPRISEAPPROVE: 'enterprise/enterpriseapprove',
  ENTERPRISELEARNS: 'enterprise/learns',
  ENTERPRISETESTS: 'enterprise/tests',
  ENTERPRISEEMPLOYEES: 'enterprise/employees',
  ENTERPRISEZJYTESTDETAILS: 'enterprise/zjytest/details',
  ENTERPRISEZJYTESTEMPLOYEES: 'enterprise/zjytest/employees',
  ENTERPRISEZJYTESTEMPLOYEERECORD: 'enterprise/zjytest/employee/record',
  ENTERPRISEBDYTESTDETAILS: 'enterprise/bdytest/details',
  ENTERPRISEBDYTESTEMPLOYEES: 'enterprise/bdytest/employees',
  ENTERPRISEBDYTESTEMPLOYEERECORD: 'enterprise/bdytest/employee/record',
  ENTERPRISEUNLOCKLOGIN: 'enterprise/unlocklogin',

  LEARNLEARNAPPROVE: 'learn/learnapprove',
  LEARCLOSE: 'learn/close',
  LEARNENTERPRISE: '/learn/enterprise',
  PENDINGAPPROVALCOUNT: 'enterprise/pendingApprovalCount',
  LEARNINGMGTYY: 'learningmgt/yy',
  LEARNINGMGT: 'learningmgt',
  LEARNINGMGTEMPLOYEE: 'learningmgt/employee',
  LEARNINGMGTEMPLOYEEMOCKEXAMRECORDS: 'learningmgt/employee/mockexamrecords',
  LEARNINGMGTEMPLOYEELESSON: 'learningmgt/employee/lesson',
  LEARNINGMGTEMPLOYEELESSONS: 'learningmgt/employee/lessons',
  LEARNINGMGTEMPLOYEELESSONLOG: 'learningmgt/employee/lesson/log',
  LEARNINGMGTEMPLOYEEFACERECORDS: 'learningmgt/employee/facerecords',
  SEARCHEXPORTEMPLOYEE: 'management/searchexportemployee',
  EXPORTEMPLOYEEEXCEL: 'management/exportemployeeexcel',
  EXPORTEMPLOYEEZP: 'management/exportemployeezp',
  EXPORTBDYEXCEL: 'management/exportbdyexcel',
  EXPORTJSGREXCEL: 'management/exportjsgrexcel',
  MAKEUPMAKEUPAPPROVE: 'makeup/makeupapprove',
  MAKEUPMAKEUPKTAPPROVE: 'makeup/makeupktapprove',
  YYHASCOURSE: 'course/yyhascourse',
  LEARNAPPROVEUPDATEINVOICE: 'learn/learnapprove/updateinvoice',
  LEARNUPDATEREGISTERZJY: 'learn/learnapprove/updateregisterzjy',
  LEARNUPDATEEMPLOYEEREGISTERZJY: 'learn/updateemployeeregisterzjy',
  LEARNAPPROVEEXPORTEXCEL: 'learn/learnapprove/exportexcel',
  LEARNAPPROVEEXPORTEMPLOYEEEXCEL: 'learn/learnapprove/exportemployeeexcel',
  LEARNAPPROVEEXPORTBDYEXCEL: 'learn/learnapprove/exportbdyexcel',
  LEARNAPPROVEEXPORTBDYZPZIP: 'learn/learnapprove/exportbdyzpzip',
  LEARNAPPROVEEXPORTBDYHZBEXCEL: 'learn/learnapprove/exportbdyhzbexcel',
  LEARNAPPROVEEXPORTJSGREXCEL: 'learn/learnapprove/exportjsgrexcel',
  LEARNEXPORTBDYBM: 'learn/export/bdybm',
  LEARNEXPORTBDYBMPICINIT: 'learn/export/bdybmpic/init',
  LEARNEXPORTBDYBMPIC: 'learn/export/bdybmpic',
  LEARNEXPORTBDYBMPICEND: 'learn/export/bdybmpic/end',
  MAKEUPAPPROVEUPDATEINVOICE: 'makeup/makeupapprove/updateinvoice',
  MAKEUPAPPROVEEXPORTAPPROVEEXCEL: 'makeup/makeupapprove/exportapproveexcel',
  MAKEUPAPPROVEEXPORTJFAPPROVEEXCEL:
    'makeup/makeupapprove/exportjfapproveexcel',

  TESTMGTROOMS: 'testmgt/rooms',
  TESTMGTROOM: 'testmgt/room',

  TESTMGTBATCHS: 'testmgt/batchs',
  TESTMGTBATCHDETAILS: 'testmgt/batchdetails',
  TESTMGTCOURSEBATCHS: 'testmgt/coursebatchs',
  TESTMGTBATCHEMPLOYEES: 'testmgt/batch/employees',
  TESTMGTBATCHEMPLOYEE: 'testmgt/batch/employee',
  TESTMGTBATCHADDEMPLOYEES: 'testmgt/batch/addemployees',
  TESTMGTBATCHJOBSTATS: 'testmgt/batch/jobstats',
  TESTMGTBATCH: 'testmgt/batch',
  TESTMGTBATCHIMPORTSPBXEXCEL: 'testmgt/batch/importspbxexcel',
  TESTMGTBATCHIMPORTEMPLOYEEEXCEL: 'testmgt/batch/importemployeeexcel',
  TESTMGTBATCHEXPORTEMPLOYEEEXCEL: 'testmgt/batch/exportemployeeexcel',
  TESTMGTBATCHPRACTICEIMPORTANT: 'testmgt/batch/practiceimportant',
  TESTMGTBATCHALLMAKEUP: 'testmgt/batch/allmakeup',

  TESTMGTTRAINS: 'testmgt/trains',
  TESTMGTCOURSETRAINS: 'testmgt/coursetrains',
  TESTMGTTRAINDETAILS: 'testmgt/traindetails',
  TESTMGTTRAINEMPLOYEES: 'testmgt/train/employees',
  TESTMGTTRAIN: 'testmgt/train',
  TESTMGTTRAINEMPLOYEE: 'testmgt/train/employee',
  TESTMGTTRAINALLEMPLOYEES: 'testmgt/train/allemployees',
  TESTMGTTRAINEXPORTEMPLOYEEEXCEL: 'testmgt/train/exportemployeeexcel',
  TESTMGTTRAININITEXPORTEMPLOYEEZP: 'testmgt/train/initexportemployeezp',
  TESTMGTTRAINEXPORTEMPLOYEEZP: 'testmgt/train/exportemployeezp',
  TESTMGTTRAINENDEXPORTEMPLOYEEZP: 'testmgt/train/endexportemployeezp',
  TESTMGTTRAINEXPORTLESSONEXCEL: 'testmgt/train/exportlessonexcel',
  TESTMGTTRAINPRACTICEIMPORTANT: 'testmgt/train/practiceimportant',
  TESTMGTTRAINALLMAKEUP: 'testmgt/train/allmakeup',

  TESTMGTSESSIONSTATES: 'testmgt/sessionStates',
  TESTMGTSESSIONS: 'testmgt/sessions',
  TESTMGTSESSIONDETAILS: 'testmgt/sessiondetails',
  TESTMGTSESSIONEMPLOYEES: 'testmgt/session/employees',
  TESTMGTSESSION: 'testmgt/session',
  TESTMGTSESSIONEMPLOYEEADMISSIONTICKET:
    'testmgt/session/employee/admissionticket',
  TESTMGTSESSIONADDEMPLOYEES: 'testmgt/session/addemployees',
  TESTMGTSESSIONEMPLOYEE: 'testmgt/session/employee',
  TESTMGTSESSIONIMPORTEMPLOYEEEXCEL: 'testmgt/session/importemployeeexcel',
  TESTMGTSESSIONASSIGNSEATNUMBER: 'testmgt/session/assignseatnumber',
  TESTMGTSESSIONINITADMISSIONTICKET: 'testmgt/session/initadmissionticket',
  TESTMGTSESSIONGENERATEADMISSIONTICKET:
    'testmgt/session/generateadmissionticket',
  TESTMGTSESSIONENDADMISSIONTICKET: 'testmgt/session/endadmissionticket',
  TESTMGTSESSIONEXPORTEMPLOYEEEXCEL: 'testmgt/session/exportemployeeexcel',
  TESTMGTSESSIONIMPORTSCOREEXCEL: 'testmgt/session/importscoreexcel',
  TESTMGTSESSIONEXPORTSCOREEXCEL: 'testmgt/session/exportscoreexcel',
  TESTMGTSESSIONEXPORTTESTEXCEL: 'testmgt/session/exporttestexcel',
  TESTMGTSESSIONPRACTICEIMPORTANT: 'testmgt/session/practiceimportant',

  TESTMGTEMPLOYEEPRACTICEIMPORTANT: 'testmgt/employee/practiceimportant',
  TESTMGTZJPXTRAINS: 'testmgt/zjpxtrains',

  ZJYTESTMGTBATCHS: 'zjytestmgt/batchs',
  ZJYTESTMGTBATCHDETAILS: 'zjytestmgt/batchdetails',
  ZJYTESTMGTBATCHEMPLOYEES: 'zjytestmgt/batch/employees',
  ZJYTESTMGTBATCH: 'zjytestmgt/batch',
  ZJYTESTMGTBATCHEMPLOYEE: 'zjytestmgt/batch/employee',
  ZJYTESTMGTBATCHAPPROVEEMPLOYEES: 'zjytestmgt/batch/approve/employees',
  ZJYTESTMGTBATCHAPPROVEEMPLOYEECOUNT:
    'zjytestmgt/batch/approve/employee/count',
  ZJYTESTMGTBATCHEMPLOYEESAPPROVE: 'zjytestmgt/batch/employees/approve',
  ZJYTESTMGTBATCHSCOREIMPORT: 'zjytestmgt/batch/score/import',
  ZJYTESTMGTBATCHEMPLOYEEIMPORT: 'zjytestmgt/batch/employee/import',

  INVOICEAPPROVEYY: 'invoiceapprove/yy',
  INVOICEAPPROVEAPPROVE: 'invoiceapprove/approve',
  INVOICEAPPROVEINVOICE: 'invoiceapprove/invoice',
  INVOICEAPPROVECOUNT: 'invoiceapprove/count',
  INVOICEAPPROVEEXPERTDPWJ: 'invoiceapprove/expert/dpwj',
  INVOICEAPPROVEEXPERTDPWJEXCEL: 'invoiceapprove/expert/dpwjexcel',

  NEWSCATEGORYS: 'news/categorys',
  NEWSYY: 'news/yy',
  NEWSDETAILS: '/news/details',
  NEWS: 'news',
  NEWSTOP: '/news/top',

  NEWSTESTPLANS: 'newstestplans',
  NEWSTESTPLAN: 'newstestplan',
  NEWSTESTPLANTYPES: 'newstestplantypes',

  EMPLOYEES: '/employee/employees',
  EMPLOYEEDETAILS: '/employee/details',
  EMPLOYEENAME: '/employee/name',
  EMPLOYEEPIC: '/employee/pic',
  EMPLOYEEIDNUMBER: '/employee/idnumber',
  EMPLOYEESEX: '/employee/sex',
  EMPLOYEEENTERPRISE: '/employee/enterprise',
  EMPLOYEERESETPASSWORD: '/employee/resetpassword',
  EMPLOYEEUNBINDOPENID: '/employee/unbindopenid',
  EMPLOYEEUNLOCKLOGIN: '/employee/unlocklogin',
  EMPLOYEEMNKSLEARNS: '/employee/mnkslearns',
  EMPLOYEEMNKSDAYS: '/employee/mnksdays',
  EMPLOYEELEARNS: '/employee/learns',
  EMPLOYEETESTS: '/employee/tests',
  EMPLOYEEPRACTICES: '/employee/practices',

  COURSE: '/course',

  JSGRTESTMGTBATCHS: 'jsgrtestmgt/batchs',
  JSGRTESTMGTALLBATCHS: 'jsgrtestmgt/allbatchs',
  JSGRTESTMGTBATCH: 'jsgrtestmgt/batch',
  JSGRTESTMGTBATCHJOBSTATS: 'jsgrtestmgt/batch/jobstats',
  JSGRTESTMGTBATCHEMPLOYEES: 'jsgrtestmgt/batch/employees',
  JSGRTESTMGTBATCHEMPLOYEE: 'jsgrtestmgt/batch/employee',
  JSGRTESTMGTBATCHEMPLOYEEIMPORT: 'jsgrtestmgt/batch/employee/import',

  JSGRTESTMGTTRAINS: 'jsgrtestmgt/trains',
  JSGRTESTMGTALLTRAINS: 'jsgrtestmgt/alltrains',
  JSGRTESTMGTTRAINEMPLOYEES: 'jsgrtestmgt/train/employees',
  JSGRTESTMGTTRAIN: 'jsgrtestmgt/train',
  JSGRTESTMGTTRAINALLEMPLOYEES: 'jsgrtestmgt/train/allemployees',
  JSGRTESTMGTTRAINEMPLOYEE: 'jsgrtestmgt/train/employee',
  JSGRTESTMGTTRAINEMPLOYEEEXPORT: 'jsgrtestmgt/train/employee/export',
  JSGRTESTMGTTRAINLESSONEXPORT: 'jsgrtestmgt/train/lesson/export',
  JSGRTESTMGTTRAININITEXPORTEMPLOYEEZP:
    'jsgrtestmgt/train/initexportemployeezp',
  JSGRTESTMGTTRAINEXPORTEMPLOYEEZP: 'jsgrtestmgt/train/exportemployeezp',
  JSGRTESTMGTTRAINENDEXPORTEMPLOYEEZP: 'jsgrtestmgt/train/endexportemployeezp',

  JSGRTESTMGTSESSIONS: 'jsgrtestmgt/sessions',
  JSGRTESTMGTSESSIONDETAILS: 'jsgrtestmgt/session/details',
  JSGRTESTMGTSESSIONEMPLOYEES: 'jsgrtestmgt/session/employees',
  JSGRTESTMGTSESSIONADDEMPLOYEES: 'jsgrtestmgt/session/addemployees',
  JSGRTESTMGTSESSION: 'jsgrtestmgt/session',
  JSGRTESTMGTSESSIONEMPLOYEE: 'jsgrtestmgt/session/employee',
  JSGRTESTMGTSESSIONEMPLOYEEIMPORT: 'jsgrtestmgt/session/employee/import',
  JSGRTESTMGTSESSIONASSIGNSEATNUMBER: 'jsgrtestmgt/session/assignseatnumber',
  JSGRTESTMGTSESSIONINITADMISSIONTICKET:
    'jsgrtestmgt/session/initadmissionticket',
  JSGRTESTMGTSESSIONGENERATEADMISSIONTICKET:
    'jsgrtestmgt/session/generateadmissionticket',
  JSGRTESTMGTSESSIONENDADMISSIONTICKET:
    'jsgrtestmgt/session/endadmissionticket',
  JSGRTESTMGTSESSIONSCOREIMPORT: 'jsgrtestmgt/session/score/import',
  JSGRTESTMGTSESSIONSCOREEXPORT: 'jsgrtestmgt/session/employee/export',

  TESTMGTPLANBATCHS: 'testmgt/planbatchs',
  TESTMGTPLANBATCHJOBSTATS: 'testmgt/planbatch/jobstats',
  TESTMGTPLANBATCHSESSIONS: 'testmgt/planbatch/sessions',
  TESTMGTPLANBATCHSESSION: 'testmgt/planbatch/session',
  TESTMGTPLANBATCH: 'testmgt/planbatch',

  BDYTESTMGTBATCHS: 'bdytestmgt/batchs',
  BDYTESTMGTBATCH: 'bdytestmgt/batch',
  BDYTESTMGTBATCHDETAILS: 'bdytestmgt/batch/details',
  BDYTESTMGTBATCHJOBSTATS: 'bdytestmgt/batch/jobstats',
  BDYTESTMGTBATCHENROLLENABLE: 'bdytestmgt/batch/enroll/enable',
  BDYTESTMGTBATCHSESSIONENABLE: 'bdytestmgt/batch/session/enable',
  // BDYTESTMGTBATCHEGWBMEXPORT: 'bdytestmgt/batch/gwbm/export',
  BDYTESTMGTBATCHEEMPLOYEEEXPORT: 'bdytestmgt/batch/employee/export',
  BDYTESTMGTBATCHPRACTICEIMPORTANT: 'bdytestmgt/batch/practiceimportant',

  BDYTESTMGTSESSIONS: 'bdytestmgt/sessions',
  BDYTESTMGTSESSIONJOBSTATS: 'bdytestmgt/session/jobstats',
  BDYTESTMGTSESSIONDETAILS: 'bdytestmgt/session/details',
  BDYTESTMGTSESSION: 'bdytestmgt/session',
  BDYTESTMGTSESSIONEMPLOYEE: 'bdytestmgt/session/employee',
  BDYTESTMGTSESSIONEMPLOYEES: 'bdytestmgt/session/employees',
  BDYTESTMGTSESSIONEMPLOYEESEATNUMBER: 'bdytestmgt/session/employee/seatnumber',
  BDYTESTMGTSESSIONEMPLOYEEIMPORT: 'bdytestmgt/session/employee/import',
  BDYTESTMGTSESSIONSCOREIMPORT: 'bdytestmgt/session/score/import',
  BDYTESTMGTSESSIONSEATNUMBERASSIGN: 'bdytestmgt/session/seatnumber/assign',
  BDYTESTMGTSESSIONZKZINIT: 'bdytestmgt/session/zkz/init',
  BDYTESTMGTSESSIONZKZGENERATE: 'bdytestmgt/session/zkz/generate',
  BDYTESTMGTSESSIONZKZEND: 'bdytestmgt/session/zkz/end',
  BDYTESTMGTSESSIONKCYBEXPORT: 'bdytestmgt/session/kcyb/export',
  BDYTESTMGTSESSIONEMPLOYEEEXPORT: 'bdytestmgt/session/employee/export',
  BDYTESTMGTSESSIONPRACTICEIMPORTANT: 'bdytestmgt/session/practiceimportant',
  BDYTESTMGTEMPLOYEEPRACTICEIMPORTANT: 'bdytestmgt/employee/practiceimportant',

  ENTERPRISEMODIFYAPPROVESYY: 'enterprise/modifyapproves/yy',
  ENTERPRISEPENDINGMODIFYAPPROVALCOUNT: 'enterprise/pendingmodifyapprovalcount',
  ENTERPRISEAPPROVEMODIFY: 'enterprise/approvemodify',

  BDYPRACTICEENROLLS: 'bdypracticeenrolls',
  BDYPRACTICEENROLLAPPROVALCOUNT: 'bdypracticeenrollApprovalCount',
  BDYPRACTICEENROLLSTATES: 'bdypracticeenroll/states',
  BDYPRACTICEENROLLDETAILS: 'bdypracticeenroll/details',
  BDYPRACTICEENROLLAPPROVE: 'bdypracticeenroll/approve',

  QUESTIONQUESTIONS: 'question/questions',
  QUESTIONBDYQUESTIONS: 'question/bdyquestions',

  LEARNINVOICELEARNINVOICES: 'learninvoice/learninvoices',
  LEARNINVOICEGKDKPCOUNT: 'learninvoice/gkdkpcount',
  LEARNINVOICEPXDKPCOUNT: 'learninvoice/pxdkpcount',
  LEARNINVOICEKP: 'learninvoice/kp',
  LEARNINVOICEEXPERTDPWJ: 'learninvoice/expert/dpwj',
  LEARNINVOICEEXPERTDPEXCEL: 'learninvoice/expert/dpexcel',
  LEARNINVOICEDETAILS: 'learninvoice/details',
  LEARNINVOICESTATES: 'learninvoice/states'
};
// 学员管理
const XYGL = {
    MYSTUDY: '/study/mystudy',
    MYSTUDYDETAILS: '/study/mystudydetails',
    MYSTUDYLESSONDETAILS: '/study/mystudylessondetails',
    UPDATEPROGRESS: '/study/updateprogress',
    COMPLETEPROGRESS: '/study/completeprogress',
    POSTTESTQUESTION: '/study/posttestquestion',
    SUBMITPOSTTEST: '/study/submitposttest',
    COURSEEXAMQUESTION: '/study/courseexamquestion',
    SUBMITCOURSEEXAM: '/study/submitcourseexam',
    STUDYFACECHECK: '/study/facecheck',
    STUDYFACEVIDEO: '/study/facevideo',
    EMPLOYEEPERSONALPROFILE: 'employee/personalprofile',
    CERTLEARNCERT: 'cert/learncert'
}

export {
    COMMON,
    LOCAL,
    QYGL,
    YYGL,
    XYGL
}



// WEBPACK FOOTER //
// ./src/store/jzjy/constants/funcUrl.js